<div class="timelineContainer">
  <div class="timelineDatesInnerContainer">
    <div class="labelAndDate" *ngFor="let d of timelineData; index as i">
      <div *ngFor="let l of d.label; index as i" class="labelsDiv">
        <label class="label">{{ l }}</label>
      </div>
      <p class="date">
        {{ d.date | date: "dd/MM/yyyy" }}
      </p>
    </div>
  </div>
  <div class="timelineShappesInnerContainer">
    <div class="circleFill"></div>
    <ng-container *ngFor="let c of timelineData; index as i">
      <div class="circleFill hollowCircle">
        <div *ngIf="!c.label.includes('Today')" class="circleInner"></div>
      </div>
    </ng-container>
    <div class="triangleFill"></div>
  </div>
</div>
